import './styles.scss';
import { SITE_URL } from '@/constants/constants';

export default {
    name: 'SubscriptionsPage',

    data() {
        return {
            active_subscription: {},
            selected_subscription: {},
            subscriptions: [],

            menu: [
                {
                    detail: false,
                    button: true,
                    text: 'Profile',
                    url: '/account/profile'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Buildings',
                    url: '/account/subscriptions'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Sync',
                    url: '/account/storage-sync'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Privacy Policy',
                    url: `${SITE_URL}/privacy-policy`
                }
            ]
        }
    },

    computed: {
        canSelect() {
            return this.selected_subscription !== this.active_subscription;
        }
    },

    created() {
        this.$store.commit('setMenuItems', this.menu);
        this.$store.commit('setMenuDetails', { title: 'Account', slug: 'account' });

        this.subscriptions = this.$store.state.subscriptions.subscriptions;
        this.active_subscription = this.$store.state.subscriptions.active_subscription.id;
        this.selected_subscription = this.active_subscription;
    },

    methods: {
        updateSubscription() {
            if (this.canSelect) {
                let subscription = this.subscriptions.find((item) => {
                    if (item.id === this.selected_subscription) {
                        return item;
                    }
                });

                this.$store.commit('setActiveSubscription', subscription);
                this.$router.push({ path: '/action' });
                this.$store.commit('setSkip', []);
                this.$store.commit('setCache', []);
                this.$store.dispatch('checkSubscriptionCache');
                this.$store.dispatch('fetchMissingDocuments');
            }
        }
    }
};